import { axiosInstance } from "./config";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const recruiterUrl = 'recruiter/'

export function useCreateRecruiter() {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: async (data) => {
        return axiosInstance.post(recruiterUrl, data);
      },
      onSuccess: (response) => {
        queryClient.setQueryData(['recruiter-profile'], response.data);
        queryClient.invalidateQueries({ queryKey: ['recruiter-dashboard'] });
      },
    });
  }

export function useGetRecruiterProfile() {
  return useQuery({
    queryKey: ['recruiter-profile'],
    queryFn: async () => {
      try {
        const response = await axiosInstance.get(recruiterUrl);
        return response.data;
      } catch (error) {
        if (error.response?.status === 404) return null;
        throw error;
      }
    },
    retry: false,
  });
}

export function useUpdateRecruiterProfile() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (data) => {
      const response = await axiosInstance.put(recruiterUrl, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['recruiter-profile']);
    },
  });
}

export function useGetRecruiterDashboard(options = {}) {
  return useQuery({
    queryKey: ['recruiter-dashboard'],
    queryFn: async () => {
      const response = await axiosInstance.get(`${recruiterUrl}dashboard/`);
      return response.data;
    },
    ...options,
  });
}

export function useSearchProfiles(searchParams) {
  return useQuery({
    queryKey: ['search-profiles', searchParams], // cache by searchParams
    queryFn: async () => {
      const params = new URLSearchParams(searchParams);
      const response = await axiosInstance.get(`recruiter/profiles/search/?${params.toString()}`);
      return response.data;
    },
    enabled: !!searchParams, // only fetch when params exist
    staleTime: 1000 * 60 * 5, // cache for 5 minutes
    keepPreviousData: true,   // keeps old data while fetching new
  });
}

export function useUnlockProfile() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (profileId) => {
      const response = await axiosInstance.post(`${recruiterUrl}profiles/${profileId}/unlock/`);
      return response.data;
    },
    onSuccess: () => {
      // Invalidate relevant queries
      queryClient.invalidateQueries(['recruiter-dashboard']);
      queryClient.invalidateQueries(['recruiter-profile']);
    },
  });
}